import createSagaMiddleware from "redux-saga";
import { createLogger } from "redux-logger";

export const sagaMiddleware = createSagaMiddleware();

const middlewares = [sagaMiddleware];

if (import.meta.env.DEV) {
  middlewares.push(createLogger());
}

export default middlewares;
